const DesktopText = ({text}) => {
  return(
    <div style={{
      overflowWrap: 'break-word',
      maxWidth: "500px",
      fontFamily: "ff-scala",
      fontSize: "24px",
      color: "black",
    }}>
      {text}
    </div>
  )
}

export default DesktopText;